import { render, staticRenderFns } from "./TrafficFineOttView.vue?vue&type=template&id=2bbc7ef4&"
import script from "./TrafficFineOttView.vue?vue&type=script&lang=js&"
export * from "./TrafficFineOttView.vue?vue&type=script&lang=js&"
import style0 from "./TrafficFineOttView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports